import { createContext, useState, useEffect } from 'react';
import { io } from 'socket.io-client';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isMember, setIsMember] = useState(false); // Store `isMember` as state
  const socket = io(process.env.REACT_APP_SERVER_URL); // WebSocket

  // Actualizar `isMember` cada vez que cambie el usuario
  useEffect(() => {
    setIsMember(
      [
        'admin',
        'coach',
        'user-adult',
        'user-youth',
        'user-padel',
        'vip',
      ].includes(user?.role)
    );
  }, [user]); // Re-run when `user` changes

  // Cargar usuario desde localStorage al iniciar
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  // Escuchar actualizaciones del usuario desde WebSockets
  useEffect(() => {
    if (!user?.id) return;

    const event = `userUpdated:${user.id}`;
    socket.on(event, updatedUser => {
      console.log('🔄 Usuario actualizado:', updatedUser);
      updateUser({
        id: updatedUser.id,
        email: updatedUser.email,
        name: updatedUser.name,
        surname: updatedUser.surname,
        dob: updatedUser.dob?.split('T')[0],
        role: updatedUser.role,
        league: updatedUser.league,
        image: updatedUser.image,
        universityCard: updatedUser.universityCard,
        dni: updatedUser.dni,
        phone: updatedUser.phone,
        subscriptions: updatedUser.subscriptions,
      });
    });

    return () => {
      socket.off(event);
    };
  }, [user?.id]);

  // Función para actualizar el usuario en el contexto y en localStorage
  const updateUser = (keyOrObject, value) => {
    setUser(prev => {
      const updatedUser =
        typeof keyOrObject === 'object' // Si recibe un objeto, lo mezcla
          ? { ...prev, ...keyOrObject }
          : { ...prev, [keyOrObject]: value };

      localStorage.setItem('user', JSON.stringify(updatedUser));
      return updatedUser;
    });
  };

  return (
    <UserContext.Provider value={{ user, setUser, isMember, updateUser }}>
      {children}
    </UserContext.Provider>
  );
};
